<template>
<div v-cloak style="background-color:#fffff;">
<div style="color:white;">
  <h1>WorkTeen Bot</h1>
</div>
<div class="container-fluid FirstBar">
<div class="col-md-12 row ">
<div class="col-md-7 col-sm-12 col-xs-12 ">
<h1>
Hey guys
</h1>
</div>
<div class="col-md-5 col-sm-6 col-xs-10 checkBar" style="align:center;">
</div>

</div>
</div>

<div class="container-fluid secondBar">
<div class="col-md-12 row ">
<div class="col-md-5 col-sm-12 col-xs-12 ">
<h1 style="text-align:center; margin-top:25%;">
Features
</h1>
</div>
<div class="col-md-7 col-sm-12 col-xs-12 checkBar2">
</div>

</div>
</div>



<div class="container-fluid thirdBar">
<div class="col-md-12 row">
<div class="col-md-7 col-sm-12 col-xs-12 checkBar3">
</div>


<div class="col-md-5 col-sm-12 col-xs-12 ">
<h1 style="text-align:center; margin-top:25%;">
Features
</h1>
</div>

</div>
</div>




<div class="EnderBar">
<h1>Talk to me on </h1>
<div  style="margin:auto 0;" align="center">
  <a href="https://www.facebook.com/workteen/" style="color:#fff"> <icon name="facebook-official" scale="5"></icon> </a>
</div>
</div>
<div>
        <transition name="fade">
            <message v-show="showMessage" class="tr pop-up-message">
                <p slot="header">This is Header</p>
                <span slot="body">This is Body</span>
            </message>
        </transition>

        <div v-if="!showMessage" class="block" @click.prevent="showMessage = true">
        <a class="button is-primary">Primary</a>
        </div>
        <div v-else-if="showMessage" class="block" @click.prevent="showMessage = false">
        <a class="button is-primary">Primary</a>
        </div>

    </div>
</div>


</template>

<script>

//Imports important page elements
import Navs from './Navs'

//Imports main Vue components in
import Vue from 'vue'

//Imports db constant from src/components/firebase.js
import {db} from './firebase'

//Material CSS imported here
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'

import { VueTyper } from 'vue-typer'
import VueTyperPlugin from 'vue-typer'
Vue.use(VueTyperPlugin)

Vue.use(VueMaterial)

import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'

export default {
  name: 'Bot',
  components :{
    Navs,
    Icon
  },
  data(){
        return{
            showMessage: false
        }
    },
    methods:{
  }
}
</script>

<style scoped>

h1{
  font-size:55px;
  text-align:center;
  font-weight: lighter;
  font-family: 'Alegreya Sans SC', sans-serif;
  /*padding:2%;*/
}
.mainPage{
  font-family: 'Lato', sans-serif;
  height:100%;
  background-color:white;
}

header{
  text-align: center;
  color:#fff;
  /*padding-top:13%;*/
  padding-bottom:13%;
  background-image: url('bg.jpg');
  background-size: cover;
  background-repeat: no-repeat;

}

.box{
  margin-top:2%;
}


.briefText{
  padding-top:12%;
  font-size:1.3em;

}

h3{
  margin:auto;
  text-align:center;
  /*font-size:24px;*/
  line-height: 28px;
}

.button{
height: 90px;
background-color: transparent;
border: 6px solid transparent;
border-radius: 50%;
color:white;
margin:2%;
width:50px;

}

hr{
  border:2px solid #CFCFCF;
  margin-top:3%;
}

.content1{
  font-size:20px;
  margin:0px;
}
.name-heading{
  text-align: center;
  font-size: 28px;
  color:#427aa1;

}

h4{
  text-align:center;
  font-size:17px;
  color:#8C8C8C;
  font-family: 'Alegreya Sans SC', sans-serif;
}


.TopBar{
  background-color: blue;
  padding:0;
  margin:0;
  height:10%;
}
.FirstBar{
  background-color: white;
}

.checkBar{
background-image: url('bar_extra1.png');
background-size: cover;
height:600px;
}

@media (max-width: 576px) {
.checkBar{
  height:300px;
  width:100%;
  align:center;
}
}
@media (max-width: 776px) {
.checkBar{
  height:300px;
  width:100%;
  align:center;
}
}
.secondBar{

  color:#fff;
  /*padding-top:13%;*/
  padding-bottom:13%;
  height:700px;
  text-align:center;
}
.checkBar2{
background-image: url('bar2_extra2.png');
background-size: cover;
background-repeat: no-repeat;
height:700px;
}
.thirdBar{
  background-color:#fff;
  color:#05668d;
  text-align:center;
  /*padding-top:13%;*/
  padding-bottom:13%;

}
.checkBar3{
height:700px;
background-image: url('bar3_extra.png');
background-size: cover;
background-repeat: no-repeat;
}
.EnderBar{
padding-top:1%;
padding-bottom:3%;
height:200px;
color:white;
}
p{
color:#fff;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// Bot.vue?834bc79c